import './Header.css';
import { Button } from '@mui/material';
import { AppBar } from '@hubdevs/adapt-design-system-core';
import { Text } from '@hubdevs/viu-ui-shared';
import logo from '../../assets/viuByHubLogo.svg';
import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useNavigate } from 'react-router-dom';

interface AppHeaderProps {
  setCorsErrorModalOpen: (open: boolean) => void;
}

export const AppHeader: React.FC<AppHeaderProps> = ({ setCorsErrorModalOpen }) => {
    const navigate = useNavigate();
    const { authState, oktaAuth } = useOktaAuth();
    useEffect(() => {
        if (authState && authState.isAuthenticated) {
            oktaAuth.getUser()
                .catch((err) => console.error(err));
        }
    }, [authState, oktaAuth]);

    const isCorsError = (err: any) => err.name === 'AuthApiError' && !err.errorCode && err.xhr?.message === 'Failed to fetch';

    const logout = async () => {
        const postLogoutRedirectUri = window.location.origin;
        try {
            await oktaAuth.signOut({ postLogoutRedirectUri });
        } catch (err) {
            if (isCorsError(err)) {
                setCorsErrorModalOpen(true);
            } else {
                console.error("Logout failed", err);
            }
        }
    };

    return (
        <AppBar className="app-header"
            leftContent={<div id="viu-logo-wrapper" onClick={() => {
                    console.log('Home navigation clicked');
                    navigate('/');
                }} >
                    <img id="viu-logo" src={logo} className="app-header-logo" alt="logo" />
                </div>
            }
            middleContent={<Text variant="h3">SP Admin Portal</Text>}
            rightContent={ <div className="app-header-btn-bar" >
                {/* <Button sx={{visibility: authState?.isAuthenticated ? "content": "hidden"}} variant="outlined" onClick={() => navigate('/data')}>View Data</Button> */}
                <Button sx={{visibility: authState?.isAuthenticated ? "content": "hidden"}} variant="outlined" onClick={logout}>Logout</Button>
            </div> }
        />
    );
};
